/** Module refusals are emitted once at the API boundary, including when a page
 * catches the rejected request and renders its own generic error state. */
export type ModuleRefusalCode = "module_not_booked" | "module_read_only";
export type ModuleRefusalListener = (code: ModuleRefusalCode, requestId?: string) => void;

let listener: ModuleRefusalListener | null = null;

export function setModuleRefusalListener(next: ModuleRefusalListener | null): void {
  listener = next;
}

export function moduleRefusalCode(status: number, body: unknown): ModuleRefusalCode | null {
  if (status !== 403 || !body || typeof body !== "object") return null;
  const code = (body as { error?: unknown }).error;
  return code === "module_not_booked" || code === "module_read_only" ? code : null;
}

export function notifyModuleRefusal(status: number, body: unknown, requestId?: string): void {
  const code = moduleRefusalCode(status, body);
  if (code) listener?.(code, requestId);
}
